export default __webpack_public_path__ + "static/media/humanoid_img.0c8c92bc.png";